import { adminHttpClient } from '../commons/adminHttpClient'
import { Feature } from 'domain/featureFlag/featureFlag'

const isFeatureFlagEnabled = (feature: Feature): Promise<boolean> =>
  adminHttpClient.get('FeatureFlag/IsEnabled', { feature })

export default isFeatureFlagEnabled
